(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
class ContactFormHandler {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('.contact-form__form');
    this.innerForm = section.querySelector('#contactFormElement');
    this.cardsGrid = section.querySelector('.contact-cards__grid');
    this.subjectSelect = section.querySelector('.contact-form__subject');
    this.messageField = section.querySelector('.contact-form__message');
    this.nameField = section.querySelector('#ContactForm-name');
    this.emailField = section.querySelector('#ContactForm-email');
    this.phoneField = section.querySelector('#ContactForm-phone');
    this.submitBtn = section.querySelector('.contact-form__submit');
    this.fabLink = document.getElementById('whatsapp-fab-link');
    this.fab = document.getElementById('contact-whatsapp-fab');
    this.fabToast = document.getElementById('whatsapp-fab-toast');
    this.fabToastDismiss = document.getElementById('whatsapp-fab-toast-dismiss');
    this.fabDragMoved = false;
    this.fabToastDismissed = false;
    this.successLink = document.getElementById('whatsapp-success-link');
    this.errorLinks = section.querySelectorAll('.contact-form__error-link');
    this.formId = section.dataset.formId;
    this.whatsappNumber = section.dataset.shopPhone;
    this.whatsappPrefix = section.dataset.whatsappPrefix || "Hi! I'd like to chat.";
    this.leadSubjectPrefix = section.dataset.leadSubjectPrefix || '[Website Lead] ';

    this.utmParams = {};
    this.lastCaptureFingerprint = null;
    this.captureTimer = null;

    if (!this.form) {
      this.initFab();
      return;
    }
    this.init();
  }

  init() {
    this.bindCardClicks();
    this.bindFormSubmit();
    this.bindSuccessWhatsApp();
    this.bindBlurCapture();
    this.bindErrorLinks();
    this.captureUtmParams();
    this.handleServerErrors();
    this.initFab();
  }

  initFab() {
    this.bindFabClick();
    this.bindFabScroll();
    this.bindFabDrag();
    this.bindFabKeyboard();
  }

  bindCardClicks() {
    if (!this.cardsGrid) return;

    this.cardsGrid.addEventListener('click', (e) => {
      const card = e.target.closest('.contact-cards__card');
      if (!card) return;

      this.cardsGrid.querySelectorAll('.contact-cards__card').forEach(c => {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
        const pt = c.querySelector('.pill-text');
        const ps = c.querySelector('.pill-selected');
        if (pt) pt.style.display = '';
        if (ps) ps.style.display = 'none';
      });

      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
      const pt = card.querySelector('.pill-text');
      const ps = card.querySelector('.pill-selected');
      if (pt) pt.style.display = 'none';
      if (ps) ps.style.display = '';

      if (this.subjectSelect) {
        const subjectVal = card.dataset.subject || '';
        Array.from(this.subjectSelect.options).forEach(opt => {
          if (opt.value === subjectVal) {
            this.subjectSelect.value = opt.value;
          }
        });
      }

      if (this.messageField) {
        const placeholder = card.dataset.placeholder;
        if (placeholder) {
          this.messageField.placeholder = placeholder;
        }
      }

      const formCard = document.getElementById('ContactForm');
      if (formCard) {
        ContactFormHandler.smoothScrollTo(formCard, 1200);
        setTimeout(() => {
          const nameField = document.getElementById('ContactForm-name');
          if (nameField) nameField.focus({ preventScroll: true });
        }, 1400);
      }
    });

    this.cardsGrid.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const card = e.target.closest('.contact-cards__card');
        if (card) {
          e.preventDefault();
          card.click();
        }
      }
    });

    if (!this.subjectSelect) return;
    this.subjectSelect.addEventListener('change', () => {
      const selectedValue = this.subjectSelect.value;

      this.cardsGrid.querySelectorAll('.contact-cards__card').forEach(c => {
        const matching = c.dataset.subject === selectedValue;
        c.classList.toggle('is-selected', matching);
        c.setAttribute('aria-checked', matching ? 'true' : 'false');
        const pt = c.querySelector('.pill-text');
        const ps = c.querySelector('.pill-selected');
        if (matching) {
          if (pt) pt.style.display = 'none';
          if (ps) ps.style.display = '';
        } else {
          if (pt) pt.style.display = '';
          if (ps) ps.style.display = 'none';
        }
        if (matching && this.messageField && c.dataset.placeholder) {
          this.messageField.placeholder = c.dataset.placeholder;
        }
      });
    });
  }

  bindFormSubmit() {
    if (!this.innerForm) return;

    this.innerForm.addEventListener('submit', (e) => {
      this.captureLead(true);
    });
  }

  bindBlurCapture() {
    if (!this.form) return;

    const captureIfValid = () => {
      const emailOk = this.emailField && this.emailField.value && this.emailField.validity.valid;
      const nameOk = this.nameField && this.nameField.value && this.nameField.value.trim().length >= 2;
      if (emailOk && nameOk) {
        this.captureLead(false);
      }
    };

    if (this.emailField) this.emailField.addEventListener('blur', captureIfValid);
    if (this.nameField) this.nameField.addEventListener('blur', captureIfValid);
  }

  dismissFabToast() {
    if (!this.fabToast) return;
    this.fabToast.classList.remove('is-visible');
    this.fabToastDismissed = true;
  }

  bindFabClick() {
    if (!this.fabLink) return;

    this.fabLink.addEventListener('click', (e) => {
      if (this.fabDragMoved) {
        e.preventDefault();
        return;
      }
      this.dismissFabToast();
      const message = this.buildWhatsAppMessage();
      if (message) {
        e.currentTarget.href = 'https://wa.me/' + this.whatsappNumber + '?text=' + encodeURIComponent(message);
      }
    });
  }

  bindSuccessWhatsApp() {
    if (!this.successLink) return;

    this.successLink.addEventListener('click', (e) => {
      const message = this.buildWhatsAppMessage();
      if (message) {
        e.currentTarget.href = 'https://wa.me/' + this.whatsappNumber + '?text=' + encodeURIComponent(message);
      }
    });
  }

  bindFabScroll() {
    if (!this.fabToast || !this.fabToastDismiss) return;

    this.fabToastDismiss.addEventListener('click', (e) => {
      e.stopPropagation();
      this.dismissFabToast();
    });

    let shown = false;

    const handler = () => {
      if (shown || this.fabToastDismissed) return;
      if (window.innerWidth > 749) return;
      if (window.scrollY < 200) return;
      shown = true;
      this.fabToast.classList.add('is-visible');
      window.removeEventListener('scroll', handler);
    };

    window.addEventListener('scroll', handler, { passive: true });
  }

  bindFabDrag() {
    const fab = this.fab;
    if (!fab || !this.fabLink) return;

    const DRAG_THRESHOLD = 8;
    const EDGE_PADDING = 16;
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;

    const getNavHeight = () => {
      const value = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'));
      return Number.isFinite(value) ? value : 70;
    };

    const clampTop = (top) => {
      const min = EDGE_PADDING;
      const max = window.innerHeight - fab.offsetHeight - getNavHeight() - EDGE_PADDING;
      return Math.min(Math.max(top, min), Math.max(min, max));
    };

    const clampLeft = (left) => {
      const min = EDGE_PADDING;
      const max = window.innerWidth - fab.offsetWidth - EDGE_PADDING;
      return Math.min(Math.max(left, min), Math.max(min, max));
    };

    const snapToEdge = (top) => {
      const rect = fab.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const onRight = centerX >= window.innerWidth / 2;
      const left = onRight
        ? window.innerWidth - rect.width - EDGE_PADDING
        : EDGE_PADDING;
      const nextTop = clampTop(top);

      fab.style.left = left + 'px';
      fab.style.top = nextTop + 'px';
      fab.style.right = 'auto';
      fab.style.bottom = 'auto';
      fab.classList.add('is-positioned');
      fab.classList.toggle('is-edge-right', onRight);
      fab.classList.toggle('is-edge-left', !onRight);
    };

    const initPosition = () => {
      if (fab.classList.contains('is-positioned')) return;
      const rect = fab.getBoundingClientRect();
      fab.style.left = rect.left + 'px';
      fab.style.top = rect.top + 'px';
      fab.style.right = 'auto';
      fab.style.bottom = 'auto';
      fab.classList.add('is-positioned', 'is-edge-right');
    };

    const onPointerDown = (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      this.fabDragMoved = false;
      dragging = false;
      this.dismissFabToast();

      initPosition();
      const rect = fab.getBoundingClientRect();
      startX = e.clientX;
      startY = e.clientY;
      startLeft = rect.left;
      startTop = rect.top;

      fab.classList.add('is-dragging');
      this.fabLink.setPointerCapture(e.pointerId);
    };

    const onPointerMove = (e) => {
      if (!this.fabLink.hasPointerCapture(e.pointerId)) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!dragging && Math.hypot(dx, dy) < DRAG_THRESHOLD) return;

      dragging = true;
      this.fabDragMoved = true;

      fab.style.left = clampLeft(startLeft + dx) + 'px';
      fab.style.top = clampTop(startTop + dy) + 'px';
    };

    const onPointerEnd = (e) => {
      if (!this.fabLink.hasPointerCapture(e.pointerId)) return;

      this.fabLink.releasePointerCapture(e.pointerId);
      fab.classList.remove('is-dragging');

      if (dragging) {
        snapToEdge(fab.getBoundingClientRect().top);
      }

      dragging = false;

      if (this.fabDragMoved) {
        window.setTimeout(() => {
          this.fabDragMoved = false;
        }, 0);
      }
    };

    this.fabLink.addEventListener('pointerdown', onPointerDown);
    this.fabLink.addEventListener('pointermove', onPointerMove);
    this.fabLink.addEventListener('pointerup', onPointerEnd);
    this.fabLink.addEventListener('pointercancel', onPointerEnd);

    window.addEventListener('resize', () => {
      if (!fab.classList.contains('is-positioned')) return;
      snapToEdge(fab.getBoundingClientRect().top);
    });
  }

  bindFabKeyboard() {
    if (!this.fab) return;
    const fab = this.fab;
    let savedBottom = null;
    let savedTop = null;

    const update = () => {
      if (!window.visualViewport) return;
      const vv = window.visualViewport;
      const keyboardHeight = window.innerHeight - vv.height;

      if (keyboardHeight > 0) {
        if (!fab.classList.contains('is-positioned')) {
          if (savedBottom === null) savedBottom = fab.style.bottom || '';
          fab.style.top = '';
          fab.style.bottom = (keyboardHeight + 16) + 'px';
        } else {
          const rect = fab.getBoundingClientRect();
          if (savedTop === null) savedTop = fab.style.top;
          const bottomVisible = rect.bottom;
          if (bottomVisible > vv.height) {
            const offset = bottomVisible - vv.height + 16;
            fab.style.top = (rect.top - offset) + 'px';
          }
        }
      } else {
        if (!fab.classList.contains('is-positioned')) {
          if (savedBottom !== null) {
            fab.style.bottom = savedBottom;
            savedBottom = null;
          }
        } else {
          if (savedTop !== null) {
            fab.style.top = savedTop;
            savedTop = null;
          }
        }
      }
    };

    window.visualViewport.addEventListener('resize', update);
    window.visualViewport.addEventListener('scroll', update);
  }

  bindErrorLinks() {
    this.errorLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.dataset.focusTarget;
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.focus({ preventScroll: true });
        }
      });
    });
  }

  handleServerErrors() {
    const errors = this.section.querySelector('#contact-form-errors');
    if (errors) {
      setTimeout(() => {
        errors.querySelector('h2')?.focus({ preventScroll: true });
      }, 100);
    }
  }

  captureUtmParams() {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    utmKeys.forEach(key => {
      const val = params.get(key);
      if (val) this.utmParams[key] = val;
    });
  }

  getFormData() {
    if (!this.form) return {};
    const get = (id) => {
      const el = this.form.querySelector('#' + id);
      return el ? el.value.trim() : '';
    };
    return {
      name: get('ContactForm-name'),
      email: get('ContactForm-email'),
      phone: get('ContactForm-phone'),
      subject: get('ContactForm-subject'),
      message: get('ContactForm-body')
    };
  }

  buildWhatsAppMessage() {
    const data = this.getFormData();
    const name = data.name || '';
    const email = data.email || '';
    const phone = data.phone || '';
    const subjectVal = data.subject || '';
    const message = data.message || '';

    const selectedOption = this.subjectSelect
      ? this.subjectSelect.options[this.subjectSelect.selectedIndex]
      : null;
    const hasSubject = selectedOption && selectedOption.value && !selectedOption.disabled;
    const subjectLabel = hasSubject ? selectedOption.text : '';

    const parts = [];

    let greeting = 'Hi!';
    if (name && email) {
      greeting += ` I'm ${name} (${email}).`;
    } else if (name) {
      greeting += ` I'm ${name}.`;
    } else if (email) {
      greeting += ` I'd like to chat. (Email: ${email})`;
    } else {
      greeting += " I'd like to chat.";
    }
    parts.push(greeting);

    if (subjectLabel) {
      parts.push(`I'm reaching out about ${subjectLabel}.`);
    }

    if (message) {
      parts.push(message);
    }

    let footer = [];
    if (phone) footer.push(`Phone: ${phone}`);
    if (email && name && (message || phone)) {
      footer.push(`Email: ${email}`);
    }
    if (footer.length) {
      parts.push(`—\n${footer.join(' | ')}`);
    }

    return parts.join('\n');
  }

  captureLead(force) {
    if (!this.formId) return;

    const data = this.getFormData();
    if (!data.name || !data.email) return;

    const fingerprint = JSON.stringify({ n: data.name, e: data.email, s: data.subject });
    if (fingerprint === this.lastCaptureFingerprint && !force) return;

    const send = () => {
      const params = new URLSearchParams();
      const map = {
        name: this.section.dataset.entryName,
        email: this.section.dataset.entryEmail,
        phone: this.section.dataset.entryPhone,
        subject: this.section.dataset.entrySubject,
        message: this.section.dataset.entryMessage
      };

      for (const [key, entryId] of Object.entries(map)) {
        if (entryId && data[key]) {
          params.append(entryId, data[key]);
        }
      }

      if (this.section.dataset.entryUrl) {
        params.append(this.section.dataset.entryUrl, window.location.href);
      }

      if (this.section.dataset.entryTimestamp) {
        params.append(this.section.dataset.entryTimestamp, new Date().toISOString());
      }

      for (const [key, val] of Object.entries(this.utmParams)) {
        const entryKey = this.section.dataset['entry' + key.replace(/^u/, 'U').replace(/(_\w)/g, m => m[1].toUpperCase())];
        if (entryKey) {
          params.append(entryKey, val);
        }
      }

      const url = 'https://docs.google.com/forms/d/e/' + this.formId + '/formResponse';

      if (force) {
        navigator.sendBeacon(url, params);
      } else {
        fetch(url, {
          method: 'POST',
          mode: 'no-cors',
          body: params
        });
      }

      this.lastCaptureFingerprint = fingerprint;
    };

    if (force) {
      clearTimeout(this.captureTimer);
      send();
    } else {
      clearTimeout(this.captureTimer);
      this.captureTimer = setTimeout(send, 5000);
    }
  }
static smoothScrollTo(targetElement, duration) {
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 50;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function easeInOutCubic(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t * t + b;
      t -= 2;
      return c / 2 * (t * t * t + 2) + b;
    }

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = easeInOutCubic(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    requestAnimationFrame(animation);
  }
}

function initContactForms() {
  document.querySelectorAll('[id^="contact-form-"]').forEach(section => {
    if (!section.dataset.initialized) {
      new ContactFormHandler(section);
      section.dataset.initialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactForms);
} else {
  initContactForms();
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('[id^="contact-form-"]')) {
    initContactForms();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bottom-nav"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.querySelector('.sticky-nav');
    if (!nav) return;

    function updateCartCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        })
        .catch(function() {});
    }

    document.addEventListener('cart:change', updateCartCount);
    updateCartCount();

    document.querySelectorAll('[data-open-menu-drawer]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var drawer = document.querySelector('header details[data-menu-drawer]');
        if (drawer) {
          drawer.setAttribute('open', '');
        }
      });
    });

    if (nav.dataset.hideOnScroll) {
      var lastScroll = 0;
      window.addEventListener('scroll', function() {
        var currentScroll = window.pageYOffset;
        if (currentScroll > lastScroll && currentScroll > 100) {
          nav.style.transform = 'translateY(100%)';
        } else {
          nav.style.transform = 'translateY(0)';
        }
        lastScroll = currentScroll;
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
